import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  Renderer2,
} from '@angular/core';
import { LiteralService, UtilsService } from 'src/app/services';

@Component({
  selector: 'app-rows-display',
  templateUrl: './rows-display.component.html',
  styleUrl: './rows-display.component.scss',
  standalone: false,
})
export class RowsDisplayComponent implements OnChanges {
  @Input() componentOpen: string;
  @Input() value: number;

  @Output() close = new EventEmitter();
  @Output() onChange = new EventEmitter<number>();

  private lastEmittedValue?: number;

  constructor(
    public literalService: LiteralService,
    public renderer: Renderer2,
    public utilsService: UtilsService,
  ) {
    renderer.listen('window', 'click', (e: Event) => {
      const modal = document.getElementById('rowsDisplayContainer')!;
      const componentOpen = document.getElementById(this.componentOpen)!;
      const close = utilsService.closeCustomModals(e, modal, componentOpen);
      if (close) {
        this.close.emit();
      }
    });
  }

  ngOnChanges(): void {
    this.lastEmittedValue = this.value;
  }

  handleChange(event: Event) {
    const value = Number((<HTMLInputElement>event.target).value);
    // Enter emits from keydown and the native change event fires right after with the same value
    if (value === this.lastEmittedValue) return;
    this.lastEmittedValue = value;
    this.onChange.emit(value);
  }

  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      this.handleChange(event);
      return;
    }
    const allowedControlKeys = [
      'Backspace',
      'Delete',
      'Tab',
      'ArrowLeft',
      'ArrowRight',
      'Home',
      'End',
    ];
    if (allowedControlKeys.includes(event.key)) return;
    if (event.metaKey || event.ctrlKey) return;
    if (!/^[0-9]$/.test(event.key)) event.preventDefault();
  }
}
